import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import Icon from "@scentregroup/ui/components/icon";
import analyticsUtils from '../../../helpers/analytics-utils';
import trackClickEvent from '../../../helpers/analytics-utils/track-event';
import { LinkContext } from '../context';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const attrsAllowList = ['target', 'rel', 'title'];

const Pane = _ref => {
  let {
    depth = 0,
    title,
    items,
    initialPath,
    onClose,
    onExit
  } = _ref;
  const Link = useContext(LinkContext);
  const {
    0: path,
    1: setPath
  } = useState(initialPath);
  useEffect(() => setPath(initialPath), [initialPath]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: classNames(style.pane),
      "data-test-id": "main-navdrawer-".concat(depth),
      "data-id": "nav_pane_Pane_div",
      children: [title && /*#__PURE__*/_jsx("div", {
        className: classNames(style.title),
        "data-id": "nav_pane_Pane_div_1",
        children: title
      }), items.map((item, i) => {
        if (!item) {
          return null;
        }

        if ('url' in item) {
          const attrs = item.attrs;
          return /*#__PURE__*/_createElement(Link, _objectSpread(_objectSpread({}, attrs && attrsAllowList.reduce((memo, key) => _objectSpread(_objectSpread({}, memo), {}, {
            [key]: attrs[key]
          }), {})), {}, {
            key: i,
            to: item.url,
            className: classNames(item.className, style.link, style.item),
            "data-test-id": "main-navdrawer-link-".concat(depth, "-").concat(i),
            onClick: () => trackClickEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_LINK_CLICK, "L".concat(depth, "-").concat(i, " ").concat(item.label)),
            "data-id": "nav_pane_Pane_Link"
          }), item.label);
        }

        if ('items' in item) {
          const children = /*#__PURE__*/_jsxs(_Fragment, {
            children: [item.title, /*#__PURE__*/_jsx(Icon, {
              size: "small",
              type: "chevron-right",
              className: classNames(style.chevron, style.icon),
              "data-test-id": "main-navdrawer-expand-icon",
              "data-id": "nav_pane_Pane_Icon"
            })]
          });

          return i === (path === null || path === void 0 ? void 0 : path[0]) ? /*#__PURE__*/_jsx("div", {
            className: classNames(item.className, style.item, style.active),
            "data-id": "nav_pane_Pane_div",
            children: children
          }, i) : /*#__PURE__*/_jsx("button", {
            className: classNames(item.className, style.item, style.link),
            "data-test-id": "main-navdrawer-button-".concat(depth, "-").concat(i),
            onClick: () => {
              setPath([i]);
              trackClickEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_MENU_OPEN, "L".concat(depth, "-").concat(i, " ").concat(item.title));
            },
            "data-id": "nav_pane_Pane_button",
            children: children
          }, i);
        }

        const x = {
          render: item
        };
        return /*#__PURE__*/_jsx(x.render, {}, i);
      }), onClose && /*#__PURE__*/_jsx("button", {
        className: classNames(style.link, style.arrow),
        onClick: onClose,
        "data-id": "nav_pane_Pane_button_6",
        children: /*#__PURE__*/_jsx(Icon, {
          size: "medium",
          type: "arrow-left",
          className: classNames(style['action-icon']),
          "data-id": "nav_pane_Pane_button_Icon"
        })
      }), onExit && /*#__PURE__*/_jsx("button", {
        className: classNames(style.link, style.cross),
        "aria-label": "Close Navigation",
        "data-test-id": "main-navdrawer-close",
        onClick: onExit,
        "data-id": "nav_pane_Pane_button",
        children: /*#__PURE__*/_jsx(Icon, {
          size: "small",
          type: "cross",
          className: classNames(style['action-icon']),
          "data-id": "nav_pane_Pane_button_Icon"
        })
      })]
    }), (() => {
      if (path !== null && path !== void 0 && path.length) {
        const i = path[0];
        const item = items[i];

        if (item && 'items' in item) {
          return /*#__PURE__*/_jsx(Pane, {
            depth: depth + 1,
            title: item.hideTitle ? undefined : item.title,
            items: item.items,
            initialPath: path === null || path === void 0 ? void 0 : path.slice(1),
            onClose: () => {
              setPath([]);
              trackClickEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_MENU_CLOSE, "L".concat(depth, "-").concat(i, " ").concat(item.title));
            },
            onExit: onExit,
            "data-id": "nav_pane_Pane"
          }, i);
        }
      }

      return null;
    })()]
  });
};

export default Pane;